import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/design-system/components/ui";

interface Props {
  title: string;
  hint?: string;
  children: ReactNode;
  /** Pass through to make charts targetable by the visual-QA harness. */
  testId?: string;
}

/** Uniform chart frame for the metrics dashboard. */
export function ChartCard({ title, hint, children, testId }: Props) {
  return (
    <Card data-testid={testId} className="h-full">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {hint ? (
          <p className="text-small text-gray-mid mt-space-1">{hint}</p>
        ) : null}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}

export function EmptyState({ label }: { label: string }) {
  return (
    <div className="flex h-[260px] items-center justify-center text-small text-gray-mid">
      {label}
    </div>
  );
}
